import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';
export var FteSwitch = styled(Switch)(function (_a) {
  var theme = _a.theme;
  return {
    '& .MuiSwitch-switchBase, & .MuiSwitch-switchBase.Mui-checked': {
      color: theme.palette.primary.main
    },
    '& .MuiSwitch-track, & .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.5
    }
  };
});